// extracted by mini-css-extract-plugin
module.exports = {"doctor-card":"doctor-card--3meOo","auth-info":"auth-info--3aZHV","follow-button":"follow-button--1sH8I"};